<div class="card o-hidden" style="height: 150px;">
    <div class="row">
        <div class="col-md-10 mx-auto">
            <div class="row">
                <div class="col-md-12">
                    <h4 class="text-center text-uppercase" *ngIf="status === 'WAITING'">Seu cadastro ainda está em avaliação</h4>
                    <h4 class="text-center text-uppercase" *ngIf="status === 'DENIED'">Seu cadastro foi negado</h4>
                </div>
            </div>
            <div class="mt-2" style="color:black" *ngIf="status === 'WAITING'">
                <p>Seu cadastro está sendo avaliado pela nossa equipe. Assim que você estiver autorizado, você receberá
                    um e-mail e poderá acessar
                    nossas
                    ofertas.</p>
            </div>
            <div class="mt-2" style="color:black" *ngIf="status === 'DENIED'">
                <p>Seu cadastro foi reprovado pela nossa equipe. Para maiores informações, nossas informações de contato estão logo abaixo.</p>
            </div>
        </div>
    </div>
</div>